// Sends the footer email signup to the merchant's Klaviyo list; falls back to the native Shopify customer form if Klaviyo can't be reached.
class SKlaviyoSignup extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.status = this.querySelector('[data-signup-status]');
    if (!this.form || !this.dataset.endpoint) return;
    this.onSubmit = this.onSubmit.bind(this);
    this.form.addEventListener('submit', this.onSubmit);
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.onSubmit);
  }

  async onSubmit(event) {
    if (this.fallingBack) return;
    event.preventDefault();
    const input = this.form.querySelector('input[type="email"]');
    const email = input.value.trim();
    if (!input.checkValidity()) {
      input.setAttribute('aria-invalid', 'true');
      this.say(this.dataset.invalidMessage);
      input.focus();
      return;
    }
    input.removeAttribute('aria-invalid');
    this.setAttribute('aria-busy', 'true');

    const body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: this.dataset.source,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
              },
            },
          },
        },
        relationships: { list: { data: { type: 'list', id: this.dataset.listId } } },
      },
    };

    try {
      const url = `${this.dataset.endpoint}?company_id=${encodeURIComponent(this.dataset.companyId)}`;
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'content-type': 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify(body),
      });
      if (!response.ok) throw new Error(String(response.status));
      this.form.reset();
      this.setAttribute('data-state', 'success');
      this.say(this.dataset.successMessage);
    } catch {
      this.fallingBack = true;
      this.form.requestSubmit();
    } finally {
      this.removeAttribute('aria-busy');
    }
  }

  say(message) {
    if (!this.status || !message) return;
    this.status.textContent = '';
    requestAnimationFrame(() => { this.status.textContent = message; });
  }
}

if (!customElements.get('s-klaviyo-signup')) customElements.define('s-klaviyo-signup', SKlaviyoSignup);
